import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './action';

let table = { ...config };
table.url = '/wms/receiving/plan';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 130,
    component: (row) => {
      return (
        <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
          {row?.code}
        </div>
      );
    },
  },

  sender: {
    title: 'Pengirim',
    width: 100,
    component: (row) => {
      return <div className="text-ellipsis">{row?.sender}</div>;
    },
  },

  ref_code: {
    title: 'Ref',
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.ref_code}
          </div>
          <small className="info">{row?.ref_type.replaceAll('_', ' ')}</small>
        </div>
      );
    },
  },

  schedule_at: {
    title: 'Tanggal Kedatangan',
    width: 100,
    component: (row) => {
      return <div>{formatDate(row?.schedule_at, 'DD/MM/YYYY')}</div>;
    },
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')?.replace('voided', 'void')}
        </span>
      );
    },
  },

  receiving_status: {
    title: 'Receive',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span className={`badge status-${row?.receiving_status}-lt ms-auto `}>
          {row?.receiving_status?.replace('_', ' ')?.replace('voided', 'void')}
        </span>
      );
    },
  },

  created_by: {
    title: 'Dibuat Oleh',
    width: 60,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.created_by}
          </div>
          <small className="info text-uppercase">
            {formatDate(row?.created_at)}
          </small>
        </div>
      );
    },
  },

  action: {
    title: '',
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};
export default table;
